
import React, { useState } from "react"

import {
  Row,
  Col,
  Form,
  Button
} from "react-bootstrap"

import { Alert } from '../Alert';
import { mailService, alertService } from '../../services';

// --
const ContactForm = () => {
  const [sendEmail, setSendEmail] = useState(0);

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const formData = {};

    Array.from(e.currentTarget.elements).forEach(field => {
      if (!field.name) return;
      formData[field.name] = field.value;
    });

    mailService.sendContact(formData)
      .then(() => {
        alertService.info('Thank you for your message!', { keepAfterRouteChange: true });
        setSendEmail(1);
        e.target.reset();
      })
      .catch(() => {
        alertService.error("There's something wrong..");
        setSendEmail(2)
      });
  }

  return (
    <>
      <Form onSubmit={handleOnSubmit}>
        <div className="controls">
          <Row>
            <Alert />
          </Row>
          <Row>
            <Col sm="6">
              <div className="mb-4">
                <Form.Label htmlFor="name" className="form-label">
                  Your First Name *
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter your first name"
                  required
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="mb-4">
                <Form.Label htmlFor="surname" className="form-label">
                  Your Last Name *
                </Form.Label>
                <Form.Control
                  type="text"
                  name="surname"
                  id="surname"
                  placeholder="Enter your last name"
                  required
                />
              </div>
            </Col>
          </Row>
          <div className="mb-4">
            <Form.Label htmlFor="email" className="form-label">
              Your email *
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="mb-4">
            <Form.Label htmlFor="message" className="form-label">
              Your message for us *
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="message"
              id="message"
              placeholder="Enter your message"
              required
            />
          </div>
          <Button type="submit" variant="outline-secondary" disabled={sendEmail > 0}>
            Send message
          </Button>
        </div>
      </Form>

    </>
  )
}

export default ContactForm;